window.init_slider = function (id) {
  let wrapper = jQuery(id).find(".slider__wrapper");
  let container = jQuery(wrapper).find(".slider__container");
  let element = jQuery(wrapper).find(".slider__element");
  let slideCount = element.length;
  let containerWidth = 100 * (slideCount + 1) + "%";

  jQuery(container).css({ width: containerWidth });
  jQuery(id).find(".slider__element:last-child").clone().prependTo(container);

  jQuery(id)
    .find(".slider__element")
    .each(function () {
      jQuery(this).css("width", 100 / (slideCount + 1) + "%");
    });

  function moveLeft() {
    container.animate(
      {
        left: +element.width(),
      },
      400,
      function () {
        jQuery(id).find(".slider__element:last-child").prependTo(container);
        container.css("left", "");
      }
    );
  }

  function moveRight() {
    container.animate(
      {
        left: -element.width(),
      },
      400,
      function () {
        jQuery(id).find(".slider__element:first-child").appendTo(container);
        container.css("left", "");
      }
    );
  }

  jQuery(id)
    .find(".slider__prev")
    .click(function (e) {
      e.preventDefault();
      moveLeft();
    });

  jQuery(id)
    .find(".slider__next")
    .click(function (e) {
      e.preventDefault();
      moveRight();
    });
};

jQuery(document).ready(function () {

  jQuery("#navbar-toggle").click(function () {
    jQuery(".header__container").toggleClass("is-nav-open");
  });

  jQuery("#mobile_menu_toggle").click(function () {
    jQuery(this).toggleClass("opened");
    jQuery("#main-menu").toggleClass("active");
  });
});
